module.exports = __webpack_public_path__ + "fd9a21dd4181f98052a202a0a01f18ab.gif";